(ns app.front.view.group.admin.import.session
  (:require [app.domain.attachment.file-formats :as file-formats]
            [app.domain.group.model :as group-model]
            [app.domain.import.model :as import-model]
            [app.domain.property.model :as property-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.select :as ui-select]
            [app.front.ui.table :as ui-table]
            [app.front.util :refer [for-frag] :as futil]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.import.attachment]
            [app.front.view.group.admin.import.common :as import-session-common]
            [app.front.view.group.admin.import.contractor-registration]
            [app.front.view.group.admin.import.form-field]
            [app.front.view.group.admin.import.inspection]
            [app.front.view.group.admin.import.licence]
            [app.front.view.group.admin.import.property]
            [app.front.view.group.admin.import.property-attribute :as import-property-attribute]
            [app.front.view.group.admin.import.subs :as import-subs]
            [app.front.view.group.admin.import.workspace]
            [app.front.view.group.admin.subs :as gas]
            [app.i18n.model :as i18n-model]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.comm :as comm]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::fetch-session
  (fn [{:keys [db]} [_ group-id session-id page]]
    {:dispatch-n   [[::entities/remove-entities (-> db
                                                    ::entities/entity-db
                                                    (get session-id)
                                                    :import-session/entities
                                                    set)]]
     :db           (-> db
                       (update-in [::import-session-common/state ::fetching session-id] #(if (nil? %) true false))
                       (assoc-in [::import-session-common/state ::page session-id] page))
     :comm/command {:command    :import/session
                    :method     :get
                    :data       (-> {:authority-group-id group-id
                                     :session-id         session-id}
                                    (p/assoc-if :page page))
                    :on-success [::fetch-session.success session-id]}}))


(rf/reg-event-fx ::fetch-session.success
  (fn [{:keys [db]} [_ session-id status {:keys [entities users]}]]
    {:db       (-> db
                   (assoc-in [::import-session-common/state ::fetching session-id] false)
                   (assoc-in [::import-session-common/state :users] users))
     :dispatch [::entities/override-entity-db status entities]}))


(rf/reg-event-fx ::upload-new-version
  (fn [_ [_ group-id session-id file-id filename file-mime-type md5-base64]]
    {:comm/command {:command    :import/upload-new-version
                    :data       {:authority-group-id group-id
                                 :session-id         session-id
                                 :file-id            file-id
                                 :file/filename      filename
                                 :file/content-type  file-mime-type
                                 :file/md5           md5-base64}
                    :on-success [::entities/apply-changes]
                    :notify     {:success :data-import/uploaded}}}))


(rf/reg-event-fx ::clear-progress-bar
  (fn [{:keys [db]} _]
    {:db (dissoc db ::progress-bar ::cancel-upload?)}))


(rf/reg-event-fx ::delete-import-attachments
  (fn [_ [_ session-id]]
    {:comm/command {:command    :import/delete-attachments
                    :data       {:import-session-id session-id}
                    :on-success [::entities/override-entity-db]
                    :notify     {:success :data-import/deleted}}
     :dispatch     [::clear-progress-bar]}))


(rf/reg-event-fx ::delete-latest-import-attachments
  (fn [_ [_ session-id]]
    {:comm/command {:command    :import/delete-latest-attachments
                    :data       {:import-session-id session-id}
                    :on-success [::entities/override-entity-db]
                    :notify     {:success :data-import/canceled}}
     :dispatch     [::clear-progress-bar]}))


(rf/reg-event-fx ::cancel-upload
  (fn [{:keys [db]} [_ session-id]]
    {:db             (assoc db ::cancel-upload? true)
     :dispatch       [::upload/cancel-upload]
     :dispatch-later {:ms 2000 :dispatch [::delete-latest-import-attachments session-id]}}))


(rf/reg-event-db ::on-upload-error
  (fn [db [_ md5]]
    (update-in db [::progress-bar :files-with-error] conj md5)))


(rf/reg-sub ::progress-bar
  :-> ::progress-bar)


(rf/reg-sub ::progress-all-items
  :<- [::progress-bar]
  :-> :all-items)


(rf/reg-sub ::progress-added-files
  :<- [::progress-bar]
  :-> :added-files)


(defn- round-to-interval
  "Takes an interval and rounds the value up to that interval
  e.g. (round-to-interval 12 5) => 15"
  [value interval]
  (-> value
      (/ interval)
      Math/ceil
      (* interval)
      int))


(rf/reg-sub ::cancel-upload?
  :-> ::cancel-upload?)


(rf/reg-sub ::progress-bar-width
  #(get-in % [::progress-bar :progress-bar-width]))


(rf/reg-event-fx ::update-progress-bar
  (fn [{:keys [db]} [_ filename tr status _response]]
    (let [processed-items-count (inc (get-in db [::progress-bar :processed-items-count]))
          all-items             (get-in db [::progress-bar :all-items])
          files-with-error      (get-in db [::progress-bar :files-with-error])
          width                 (some-> processed-items-count
                                        (/ all-items)
                                        (* 100)
                                        (round-to-interval 5))
          upload-completed?     (= all-items (+ processed-items-count (count files-with-error)))]
      {:db (-> db
               (assoc-in [::progress-bar :processed-items-count] processed-items-count)
               (assoc-in [::progress-bar :progress-bar-width] (if upload-completed? 100 width)))
       :fx [(when (and (not (::cancel-upload? db)) (= processed-items-count all-items))
              [:dispatch [:notifications/add :toast :success :success :data-import/files-added]])
            (when (= status 304)
              [:dispatch [:notifications/add :toast :success :success (tr [:upload/already-uploaded] [filename])]])
            (when upload-completed?
              [:dispatch-later {:ms 2000 :dispatch [::upload-completed]}])]})))


(rf/reg-event-fx ::upload-ready
  (fn [_ _]
    {:fx [[:dispatch-later {:ms 2000 :dispatch [::upload-completed]}]]}))


(rf/reg-event-fx ::upload-completed
  (fn [{:keys [db]} _]
    {:db (-> db
             (dissoc ::progress-bar)
             (assoc-in [::progress-bar :upload-completed?] false))}))


(rf/reg-sub ::upload-completed?
  :<- [::progress-bar]
  (fn [progress-bar _]
    (let [processed-items-count (:processed-items-count progress-bar)
          all-items             (:all-items progress-bar)
          files-with-error      (:files-with-error progress-bar)
          upload-completed?     (= all-items (+ processed-items-count (count files-with-error)))]
      upload-completed?)))


(def initial-progress-bar-data
  {:pending-files         0
   :processed-items-count 0
   :all-items             0
   :progress-bar-width    0
   :files-with-error      []
   :added-files           []})


(rf/reg-event-fx ::start-progress-bar
  (fn [{:keys [db]} [_ session-id items]]
    {:comm/command {:command :import/start-attachment-upload
                    :data    {:import-session-id session-id}}
     :db           (-> db
                       (assoc ::progress-bar (assoc initial-progress-bar-data
                                                    :all-items (count items)
                                                    :progress-bar-width 5))
                       (assoc ::cancel-upload? false))}))


(rf/reg-sub ::fetching
  :<- [::import-session-common/state]
  :-> ::fetching)


(rf/reg-sub ::fetching?
  :<- [::fetching]
  (fn [fetching [_ session-id]]
    (get fetching session-id)))


(rf/reg-sub ::current-page
  :<- [::import-session-common/state]
  (fn [state [_ session-id]]
    (get-in state [::page session-id])))


(rf/reg-event-fx ::start-import
  (fn [_ [_ authority-group-id session-id]]
    {:comm/command {:command          :import/start-import
                    :data             (util/mmap authority-group-id session-id)
                    :notify           {:success :data-import/import-started}
                    :on-success       [::entities/merge-entity-db]
                    :finally-dispatch [::fetch-session authority-group-id session-id 0]}
     :fx           [[:dispatch [::entities/update-entity
                                session-id
                                {:domain/state :import-session.state/in-progress}]]]}))


(rf/reg-event-fx ::remove-session
  (fn [_ [_ authority-group-id session-id]]
    {:comm/command {:command    :import/remove-session
                    :data       (util/mmap authority-group-id session-id)
                    :notify     {:success :data-import/import-removed}
                    :on-success [::remove-session.success authority-group-id]}}))

(rf/reg-event-fx ::remove-session.success
  (fn [_ [_ group-id status data]]
    {:route/push {:route  :view/group.admin.import
                  :params (util/mmap group-id)}
     :dispatch   [::entities/apply-changes status data]}))

(rf/reg-event-fx ::duplicate-session
  (fn [_ [_ authority-group-id session-id]]
    {:comm/command {:command    :import/duplicate-session
                    :data       (util/mmap authority-group-id session-id)
                    :notify     {:success :data-import/import-duplicated}
                    :on-success [::duplicate-session.success authority-group-id]}}))

(rf/reg-event-fx ::duplicate-session.success
  (fn [_ [_ group-id _ {:keys [session-id]}]]
    {:route/push {:route  :view/group.admin.import.session
                  :params (util/mmap group-id session-id)}}))

(rf/reg-event-fx ::finalize-import
  (fn [{:keys [db]} [_ authority-group-id session-id]]
    {:db           (assoc db ::finalizing-in-progress? true)
     :comm/command {:command          :import/finalize-import
                    :data             (util/mmap authority-group-id session-id)
                    :notify           {:success :data-import/finalized}
                    :on-success       [::entities/merge-entity-db]
                    :finally-dispatch [::finalize-import.done]}}))

(rf/reg-event-db ::finalize-import.done
  (fn [db _]
    (dissoc db ::finalizing-in-progress?)))

(rf/reg-event-fx ::restore-to-draft
  (fn [_ [_ authority-group-id session-id]]
    {:comm/command {:command    :import/restore-to-draft
                    :data       (util/mmap authority-group-id session-id)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::select-default-attachment-type
  (fn [_ [_ authority-group-id session-id attachment-type-id]]
    {:comm/command {:command    :import/set-default-attachment-type
                    :data       (util/mmap authority-group-id session-id attachment-type-id)
                    :notify     {:success :data-import/attachment-type-success}
                    :on-success [::entities/apply-changes]}}))


(rf/reg-sub ::file-summary
  import-subs/session-entity-signal
  :-> :import-session/file-summary)

(rf/reg-sub ::file-entity
  import-subs/session-entity-signal
  :-> :import-session/file)

(rf/reg-sub ::missing-file?
  (fn [[_ session-id]]
    (rf/subscribe [::file-entity session-id]))
  :-> nil?)

(rf/reg-sub ::loading-summary?
  (fn [[_ session-id]]
    [(rf/subscribe [::file-summary session-id])
     (rf/subscribe [::missing-file? session-id])])
  (fn [[summary missing-file?] _]
    (and (nil? summary)
         (not missing-file?))))


(rf/reg-sub ::summary-error
  (fn [[_ session-id]]
    (rf/subscribe [::file-summary session-id]))
  :-> :error)


(rf/reg-sub ::session-type
  import-subs/session-entity-signal
  :-> :import-session/type)


(rf/reg-sub ::default-attachment-type
  import-subs/session-entity-signal
  :-> :import-session/default-attachment-type)


(rf/reg-sub ::filename
  import-subs/session-entity-signal
  (fn [session _]
    (-> session :import-session/file :file/filename)))


(rf/reg-sub ::entities
  import-subs/session-entity-signal
  (fn [session _]
    (->> session
         :import-session/entities
         (sort-by :db/id))))


(rf/reg-sub ::n-pages
  (fn [[_ session-id]]
    (rf/subscribe [::entities session-id]))
  (fn [entities _]
    (-> entities count (/ import-model/page-size) js/Math.round inc)))


(rf/reg-sub ::errors
  import-subs/session-entity-signal
  (fn [session _]
    (->> session
         :import-session/errors)))

(rf/reg-sub ::visible-errors
  (fn [[_ session-id]]
    (rf/subscribe [::errors session-id]))
  (fn [errors]
    (->> errors
         (remove nil?)
         (sort import-model/error-sort))))

(rf/reg-sub ::visible-error-count
  (fn [[_ session-id]]
    (rf/subscribe [::visible-errors session-id]))
  :-> count)

(rf/reg-sub ::total-error-count
  (fn [[_ session-id]]
    (rf/subscribe [::errors session-id]))
  :-> count)

(rf/reg-sub ::errors-omitted?
  (fn [[_ session-id]]
    [(rf/subscribe [::total-error-count session-id])
     (rf/subscribe [::visible-error-count session-id])])
  (fn [[total visible]]
    (< visible total)))

(rf/reg-sub ::has-errors?
  (fn [[_ session-id]]
    (rf/subscribe [::errors session-id]))
  (fn [errors _]
    (->> errors (some import-model/error?))))

(rf/reg-sub ::has-warnings?
  (fn [[_ session-id]]
    (rf/subscribe [::errors session-id]))
  (fn [errors _]
    (->> errors (some import-model/warning?))))

(rf/reg-sub ::has-pending-messages?
  import-subs/session-entity-signal
  (fn [session _]
    (-> session :import-session/pending-messages seq boolean)))

(rf/reg-sub ::can-finalize?
  (fn [[_ session-id]]
    [(rf/subscribe [::has-errors? session-id])
     (rf/subscribe [::has-pending-messages? session-id])])
  (fn [[errors messages] _]
    (and (not errors) (not messages))))

(def attachment-import-types
  #{:import-session.type/attachment
    :import-session.type/property-attachment})

(defn attachment-import?
  [import-type]
  (contains? attachment-import-types import-type))

(rf/reg-sub ::import-type
  import-subs/session-entity-signal
  :-> :import-session/type)

(rf/reg-sub ::import-state
  import-subs/session-entity-signal
  :-> :domain/state)

(rf/reg-sub ::missing-attachments
  import-subs/session-entity-signal
  (fn [session _]
    (-> session :import-session/missing-attachments seq)))

(rf/reg-sub ::primary-permit-type
  :<- [::gas/group]
  :-> group-model/primary-permit-type)

(rf/reg-sub ::mappings
  ;; Returns the configured mappings customized (hidden and required fields) for the current permit type
  (fn [[_ session-id]]
    [(rf/subscribe [::session-type session-id])
     (rf/subscribe [::primary-permit-type])
     (rf/subscribe [::ff/enabled-flags])
     (rf/subscribe [::gas/group-features])])
  (fn [[session-type primary-permit-type enabled-flags group-features] _]
    (->> session-type
         (get import-model/mappings)
         (filter (partial import-model/feature-flag-compatible-mapping? enabled-flags))
         (filter (partial import-model/group-feature-compatible-mapping? group-features))
         (keep (fn [[_ mapping-opts :as mapping]]
                 (when (import-model/shown-mapping? primary-permit-type mapping-opts)
                   (->> mapping-opts
                        (import-model/required-mapping? primary-permit-type)
                        (assoc-in mapping [1 :required?]))))))))


(defn mappings-signal [[_ session-id]]
  (rf/subscribe [::mappings session-id]))


(rf/reg-sub ::fixed-mappings
  mappings-signal
  (fn [mappings _]
    (->> mappings
         (filter (comp :unique? second))
         (group-by (comp :group second)))))


(rf/reg-sub ::free-mappings
  mappings-signal
  (fn [mappings _]
    (->> mappings
         (filter (complement (comp :unique? second))))))

(rf/reg-sub ::free-mapping-keys-of-types
  (fn [[_ session-id]]
    (rf/subscribe [::free-mappings session-id]))
  (fn [mappings [_ _ types]]
    (->> mappings
         (filter (comp types :type second))
         (map first)
         set)))

(rf/reg-sub ::show-free-mappings?
  (fn [[_ session-id]]
    (rf/subscribe [::free-mappings session-id]))
  (fn [free-mappings _]
    (boolean (seq free-mappings))))


(defn target=-fn [target-expected]
  (fn [[target _]]
    (= target target-expected)))

(defn unused-or-free-mapping-fn [mapping-defs]
  (fn [{:import-session-mapping/keys [target]}]
    (or (nil? target)
        (-> mapping-defs
            (p/find-first (target=-fn target))
            second
            :unique?
            not))))


(defn find-mapping-fn [used-mappings]
  (fn [{:keys [ix]}]
    (-> used-mappings
        (p/find-first {:import-session-mapping/col-ix ix}))))


(rf/reg-sub ::cols-available
  (fn [[_ session-id]]
    [(rf/subscribe [::selected-sheet session-id])
     (rf/subscribe [::import-subs/current-mappings session-id])
     (rf/subscribe [::mappings session-id])])
  (fn [[sheet used-mappings mapping-defs] _]
    (->> sheet
         :cols
         (map (juxt identity (find-mapping-fn used-mappings)))
         (filter (comp (unused-or-free-mapping-fn mapping-defs)
                       second)))))

(rf/reg-sub ::selected-sheet-ix
  import-subs/session-entity-signal
  :-> :import-session/selected-sheet)


(rf/reg-sub ::selected-sheet
  (fn [[_ session-id]]
    [(rf/subscribe [::file-summary session-id])
     (rf/subscribe [::selected-sheet-ix session-id])])
  (fn [[file-summary sheet-ix] _]
    (-> file-summary
        :sheets
        (p/find-first {:ix sheet-ix}))))

(rf/reg-event-fx ::select-sheet
  (fn [_ [_ authority-group-id session-id sheet-ix]]
    {:comm/command {:command    :import/select-sheet
                    :data       (util/mmap authority-group-id
                                           session-id
                                           sheet-ix)
                    :on-success [::entities/apply-changes]}}))

(rf/reg-sub ::multiple-sheets?
  (fn [[_ session-id]]
    (rf/subscribe [::file-summary session-id]))
  (fn [summary _]
    (-> summary :sheets count (> 1))))


(rf/reg-sub ::selected-cols
  (fn [[_ session-id]]
    (rf/subscribe [::import-subs/current-mappings session-id]))
  (fn [mappings _]
    (->> mappings
         (map :import-session-mapping/col-ix)
         set)))


(rf/reg-sub ::selections-ok?
  (fn [[_ session-id]]
    [(rf/subscribe [::session-type session-id])
     (rf/subscribe [::mappings session-id])
     (rf/subscribe [::import-subs/current-mappings session-id])
     (rf/subscribe [::default-attachment-type session-id])])
  (fn [[session-type mappings current-mappings default-attachment-type] _]
    (let [required-mappings (->> mappings
                                 (filter (comp :required? second))
                                 (map first)
                                 set)
          actual-mapping    (->> current-mappings
                                 (map :import-session-mapping/target)
                                 set)]
      (and (empty? (set/difference required-mappings actual-mapping))
           (or (not (attachment-import? session-type))
               default-attachment-type)))))


(rf/reg-sub ::is-imported?
  import-subs/session-entity-signal
  (fn [session _]
    (du/in-state? :import-session.state/imported session)))


(rf/reg-sub ::finalizing-in-progress? :-> ::finalizing-in-progress?)

(rf/reg-sub ::too-many-rows?
  (fn [[_ session-id]]
    [(rf/subscribe [::selected-sheet session-id])])
  (fn [{{:keys [n-rows]} :metadata} _]
    (> n-rows import-model/max-allowed-rows)))

(defn filter-and-fetch-target-with-duplicate-settings [mappings]
  (->> mappings
       (filter #(contains? % :import-session-mapping/settings))
       (filter (fn [mapping]
                 (let [settings (vals (:import-session-mapping/settings mapping))]
                   (not= (count settings) (count (distinct settings))))))
       (map :import-session-mapping/target)
       seq))

(rf/reg-sub ::duplicate-settings
  (fn [[_ session-id]]
    (rf/subscribe [::import-subs/current-mappings session-id]))
  :-> filter-and-fetch-target-with-duplicate-settings)

(rf/reg-sub ::can-start-read?
  (fn [[_ session-id]]
    [(rf/subscribe [::selections-ok? session-id])
     (rf/subscribe [::import-subs/is-draft? session-id])
     (rf/subscribe [::too-many-rows? session-id])
     (rf/subscribe [::duplicate-settings session-id])])
  (fn [[selections-ok? session-draft? too-many-rows? duplicate-settings] _]
    (and selections-ok? session-draft? (not too-many-rows?) (empty? duplicate-settings))))

(rf/reg-event-fx ::error-handler
  (fn [_ _]
    {:dispatch [:notifications/add :toast :error :error/file-upload-title :error/file-upload-caption]}))


(rf/reg-event-fx ::add-file-for-import
  (fn [{:keys [db]} [_ tr group-id session-id file-id filename file-mime-type md5-base64 fullpath]]
    (when (not (::cancel-upload? db))
      {:db           (update-in db [::progress-bar :pending-files] inc)
       :comm/command {:command          :import/add-file-for-import
                      :data             {:authority-group-id group-id
                                         :import-session-id  session-id
                                         :file-id            file-id
                                         :file/filename      filename
                                         :file/full-path     fullpath
                                         :file/content-type  file-mime-type
                                         :file/md5           md5-base64}
                      :on-success       [::add-file-for-import.success]
                      :finally-dispatch [::update-progress-bar filename tr]
                      :on-error         [::error-handler]
                      :on-server-error  [::error-handler]}})))


(rf/reg-event-fx ::add-file-for-import.success
  (fn [{:keys [db]} [_ status resp]]
    {:db (-> db
             (update-in [::progress-bar :pending-files] dec)
             (update-in [::progress-bar :added-files] conj (:file-id resp)))
     :fx [[:dispatch [::entities/merge-entity-db status (:entities resp)]]]}))

(defn col-identifier [{:keys [name ix]}]
  (str (import-model/excel-col-name ix)
       (when-not (str/blank? name)
         (str ": " name))))

(defn mapping-target-select [{:keys [session-id mapping-target settings group-id selected-col required? sheet tr type]}]
  (let [selected-cols     (disj (<sub [::selected-cols session-id])
                                (:ix selected-col))
        matching-types-fn (if (:property-attribute-template-id settings)
                            import-model/property-attribute-matching-types-fn
                            import-model/default-matching-types-fn)]
    [:div
     (if (<sub [::import-subs/is-draft? session-id])
       [ui-select/select {:id              (str mapping-target "-select-col")
                          :on-change       #(>evt [::import-subs/set-mapping
                                                   {:authority-group-id group-id
                                                    :session-id         session-id
                                                    :col-ix             (:ix %)
                                                    :mapping-key        mapping-target
                                                    :settings           settings}])
                          :required        required?
                          :select-text     (tr [:select-option])
                          :values          (->> (:cols sheet)
                                                (remove (comp selected-cols :ix)))
                          :value           selected-col
                          :val->str        col-identifier
                          :allow-empty?    (not required?)
                          :val->token      :ix
                          :label-text      (tr [:data-import/use-column])
                          :disabled-values (->> sheet
                                                :cols
                                                (filter (complement (matching-types-fn type)))
                                                ;; TODO disable used columns
                                                set)}]
       [:div.mt-6 (-> selected-col col-identifier)])]))

(defn free-mapping-target-select [{:keys [draft? ix group-id session-id col values target tr]}]
  (if draft?
    [ui-select/select {:id           (str "col-mapping-" ix)
                       :on-change    #(>evt [::import-subs/set-mapping
                                             {:authority-group-id group-id
                                              :session-id         session-id
                                              :col-ix             ix
                                              :mapping-key        %
                                              :settings           {:label (:name col)}}])
                       :required     false
                       :allow-empty? true
                       :values       values
                       :value        target
                       :val->str     (comp tr vector)
                       :label-text   (tr [:data-import/import-as])}]
    [:span (tr [target])]))

(defn- title
  [[mapping-target {:keys [title]}] tr]
  (tr [(or title mapping-target)]))

(defn fixed-mapping
  "A single import mapping from import spreadsheet column to specific entity field, e.g. permit number"
  [{:keys [group-id session-id sheet]}
   [mapping-target {:keys [type required?]} :as mapping]]
  (let [current-mappings              (<sub [::import-subs/current-mappings session-id])
        {:import-session-mapping/keys
         [settings
          col-ix]}                    (-> current-mappings
                                          (p/find-first {:import-session-mapping/target mapping-target}))
        selected-col                  (-> sheet
                                          :cols
                                          (p/find-first {:ix col-ix}))
        tr                            (<sub [::gas/group-tr])]
    [import-session-common/mapping-config
     (util/mmap {:title         (title mapping tr)
                 :select        [mapping-target-select (util/mmap session-id
                                                                  mapping-target
                                                                  group-id
                                                                  selected-col
                                                                  required?
                                                                  sheet
                                                                  tr
                                                                  type)]
                 :settings      (when (and selected-col settings)
                                  [import-session-common/mapping-settings
                                   (util/mmap {:target mapping-target
                                               :ix     col-ix}
                                              group-id session-id settings tr)])
                 :configurable? (and selected-col settings)}
                tr type)]))


(defn fixed-mappings [{:keys [session-id] :as opts}]
  (let [tr (<sub [::gas/group-tr])]
    (for-frag [[group mappings] (<sub [::fixed-mappings session-id])]
      [:div.mt-8
       (when group [:h4 (tr [group])])
       [:ul (when group {:class "ml-4"})
        (for-frag [mapping mappings]
          [fixed-mapping opts mapping])]])))

(defn free-mapping
  "A single import mapping from import spreadsheet column to form field"
  [{:keys [group-id session-id]}
   [{:keys [ix types] :as col} {:import-session-mapping/keys [target settings]}]]
  (let [tr     (<sub [::gas/group-tr])
        lang   (<sub [:language])
        draft? (<sub [::import-subs/is-draft? session-id])
        values (<sub [::free-mapping-keys-of-types session-id types])]
    (when (and (or draft? target)
               (seq values))
      [import-session-common/mapping-config
       (util/mmap {:title         (col-identifier col)
                   :select        [free-mapping-target-select (util/mmap draft? ix group-id session-id col lang values target tr)]
                   :settings      (when (and target settings)
                                    [import-session-common/mapping-settings
                                     (util/mmap target group-id session-id ix settings tr)])
                   :configurable? (and target settings)}
                  tr)])))

(defn free-mappings [{:keys [session-id] :as opts}]
  (when (<sub [::show-free-mappings? session-id])
    (let [tr (<sub [::gas/group-tr])]
      [:div
       [:h3.mt-8.font-lg (tr [:data-import/free-mappings])]
       [:ul
        (for-frag [column (<sub [::cols-available session-id])]
          [free-mapping opts column])]])))

(defn property-attribute-column-mapping
  "A single import mapping from import spreadsheet column to specific entity field, e.g. permit number"
  [{:keys [group-id session-id sheet]}
   property-attribute-template property-attribute-template-subtype]
  (let [lang                           (<sub [:language])
        mapping-target                 :data-import.mapping/property-attribute
        property-attribute-template-id (:db/id property-attribute-template)
        current-mappings               (<sub [::import-subs/current-mappings session-id])
        {:import-session-mapping/keys
         [settings
          col-ix]}                     (-> current-mappings
                                           (p/find-first
                                             #(and (= (:import-session-mapping/target %) mapping-target)
                                                   (= property-attribute-template-id (-> % :import-session-mapping/settings :property-attribute-template-id))
                                                   (= property-attribute-template-subtype (-> % :import-session-mapping/settings :property-attribute-template-subtype)))))
        selected-col                   (-> sheet
                                           :cols
                                           (p/find-first {:ix col-ix}))
        tr                             (<sub [::gas/group-tr])
        required?                      true
        type                           (:property-attribute-template/type property-attribute-template)
        configurable?                  (contains? #{:property-attribute-template.type/select} type)
        settings                       (-> (or settings {})
                                           (assoc :property-attribute-template-id property-attribute-template-id)
                                           (assoc :property-attribute-template-subtype property-attribute-template-subtype))]
    [import-session-common/mapping-config
     (util/mmap {:title         (property-model/attribute-template-name property-attribute-template lang)
                 :select        [mapping-target-select (util/mmap session-id
                                                                  mapping-target
                                                                  settings
                                                                  group-id
                                                                  selected-col
                                                                  required?
                                                                  sheet
                                                                  tr
                                                                  type)]
                 :settings      (when (and selected-col settings)
                                  [import-session-common/mapping-settings
                                   (util/mmap {:target      :data-import.mapping/property-attribute
                                               :target-type type
                                               :ix          col-ix}
                                              group-id session-id settings tr)])
                 :configurable? configurable?}
                tr type property-attribute-template-subtype)]))

(defn property-attribute-column-mappings [opts]
  (let [tr (<sub [::gas/group-tr])]
    [:div.mt-8
     [:h3.mt-8.font-lg (tr [:data-import/column-mapping])]
     [:ul
      (for-frag [attribute-template (<sub [::import-property-attribute/enabled-attribute-templates])
                 template-subtype (if (= (:property-attribute-template/type attribute-template)
                                         :property-attribute-template.type/date-range)
                                    [:date-range-start :date-range-end]
                                    [nil])]
        [property-attribute-column-mapping opts attribute-template template-subtype])]]))

(defn sheet-selections [{:keys [import-type] :as opts}]
  [:div.mt-8
   [fixed-mappings opts]
   (if (contains? #{:import-session.type/property-attributes :import-session.type/property} import-type)
     [property-attribute-column-mappings opts]
     [free-mappings opts])])

(defn page-selector [{:keys [session-id group-id]}]
  (let [current-page (<sub [::current-page session-id])
        n-pages      (<sub [::n-pages session-id])]
    (when (> n-pages 1)
      [:div.flex.flex-wrap
       (for-frag [page (range n-pages)]
         [:a.mx-4 {:href  (href/href :view/group.admin.import.session
                                     (util/mmap session-id group-id)
                                     (util/mmap page))
                   :class (when (= current-page page)
                            "font-bold")}
          (inc page)])])))

(defn import-entities-title [import-type state]
  (case import-type
    :import-session.type/workspace
    (if (= state :import-session.state/done)
      :data-import/workspaces
      :data-import/draft-workspaces)
    :import-session.type/inspection
    (if (= state :import-session.state/done)
      :data-import/inspections
      :data-import/draft-inspections)
    :data-import/entities))

(defn entities-section [{:keys [session-id group-id] :as props}]
  (let [entities     (<sub [::entities session-id])
        import-type  (<sub [::import-type session-id])
        import-state (<sub [::import-state session-id])
        tr           (<sub [::gas/group-tr])]
    (cond
      (->> entities (remove nil?) seq)
      [:section
       [:h4.mb-4 (tr [(import-entities-title import-type import-state)])]
       (when (<sub [::has-pending-messages? session-id])
         [ui/tag {:color :yellow}
          (tr [:data-import/messages-pending])])
       [:div.flex
        (when (<sub [::is-imported? session-id])
          (if (<sub [::finalizing-in-progress?])
            [:div (cc/inline-loading {:description (tr [:import-session.state/finalizing])})]
            [ui/modal-confirmation-button
             {:id                  "finalize-import-button"
              :trigger-button-text (tr [:data-import/finalize])
              :tr                  tr
              :trigger-button-opts {:disabled (not (<sub [::can-finalize? session-id]))}
              :on-yes-click        #(>evt [::finalize-import group-id session-id])}
             [:span (tr [:data-import/finalize-description])]]))
        [page-selector props]]
       [ui-table/modern-responsive-table
        {:items      (remove nil? entities)
         :class      "mt-4"
         :tr         tr
         :get-status (fn [entity]
                       (let [error-entities (:import-session-error/_entity entity)]
                         (cond
                           (= :import-session.state/done import-state) :ok
                           (some import-model/error? error-entities) :critical
                           (some import-model/warning? error-entities) :warning
                           :else :task)))
         :link       {:make-href   (partial import-session-common/entity-href import-type)
                      :description (tr [:data-import/view-entity])}
         :cols       (import-session-common/entities-cols import-type)}]]
      (seq entities) [section/section-skeleton]
      :else nil)))

(defn error-link
  [{:keys [session-id group-id]} output-format]
  [:span.ml-1
   "["
   [file-download/download-link
    :import/download-error-report
    {:session-id         session-id
     :authority-group-id group-id
     :format             output-format}
    (str "." output-format)]
   "]"])

(defn download-error-report
  [args]
  (let [tr (<sub [::gas/group-tr])]
    [:<>
     [:span
      (tr [:data-import/download-report])]
     (for-frag [output-format import-model/error-report-formats]
       [error-link args (name output-format)])]))

(defn error-title
  [{:keys [session-id]}]
  (let [tr (<sub [::gas/group-tr])]
    [:h4.mb-4
     (if (<sub [::errors-omitted? session-id])
       (tr [:data-import/errors-omitted]
           [(<sub [::visible-error-count session-id])
            (<sub [::total-error-count session-id])])
       (tr [:data-import/errors]))]))

(defn errors-section [{:keys [session-id group-id]}]
  (let [tr                  (<sub [::gas/group-tr])
        errors              (<sub [::visible-errors session-id])
        import-type         (<sub [::import-type session-id])
        missing-attachments (<sub [::missing-attachments session-id])]
    [:<>
     (when (or (<sub [::has-errors? session-id])
               (<sub [::has-warnings? session-id])
               missing-attachments)
       [:section
        [error-title (util/mmap session-id)]
        (when (or (<sub [::has-errors? session-id])
                  (<sub [::has-warnings? session-id]))
          [:<>
           [download-error-report (util/mmap session-id group-id)]
           [ui-table/modern-responsive-table
            {:items      errors
             :class      "mt-4"
             :tr         tr
             :get-status (fn [error]
                           (cond (import-model/error? error) :critical
                                 (import-model/warning? error) :warning))
             :link       {:description (tr [:data-import/view-entity])
                          :make-href   (comp (partial import-session-common/entity-href import-type)
                                             :import-session-error/entity)}
             :cols       [[:import-session-error/row
                           #(or (some-> % :import-session-error/row (+ 2)) "-")
                           {:width "125px"}]
                          [:import-session-error/level
                           (comp tr vector import-model/error-level)
                           {:width "115px"}]
                          [:import-session-error/kind
                           (comp tr vector :import-session-error/kind)]
                          [:import-session-error/description
                           :import-session-error/description]]}]
           [:p.py-2 (tr [:data-import/errors-guide])]])
        (when missing-attachments
          [:div.my-10
           [:h5 (tr [:data-import/missing-file-mentions])]
           [ui-table/modern-responsive-table
            {:items      missing-attachments
             :class      "mt-4"
             :tr         tr
             :get-status (fn [_]
                           :warning)
             :cols       [[nil
                           identity]]}]])])]))


(defn imported-file [{:keys [session-id group-id]}]
  (let [tr (<sub [::gas/group-tr])]
    [:div
     [file-download/download-link
      :import/download-file
      {:session-id session-id}
      (<sub [::filename session-id])
      {:class "font-bold text-lg"}]
     (when (<sub [::import-subs/is-draft? session-id])
       [:div.mt-4
        [:h3 (tr [:data-import/upload-new-version])]
        [upload/upload-area "upload-new-import-version"
         {:accept-types    ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            "application/vnd.ms-excel"]
          :additional-help (tr [:data-import/upload-help-version])
          :attach-file-fn  (fn [file-id filename file-mime-type md5-base64]
                             (>evt [::upload-new-version
                                    group-id
                                    session-id
                                    file-id
                                    filename
                                    file-mime-type
                                    md5-base64]))}]])]))


(defn uploaded-files [tr session]
  (let [attachments       (->> (:import-session/attachments session)
                               (sort-by :entity/created >))
        progress-width    (<sub [::progress-bar-width])
        all-items         (<sub [::progress-all-items])
        upload-completed? (<sub [::upload-completed?])
        added-items-count (count (<sub [::progress-added-files]))]
    (when upload-completed?
      (>evt [::upload-ready]))
    [:<>
     (when progress-width
       [:div.border.border-solid.border-gray-300.rounded-md.flex.relative.leading-8.h-18.mb-2.transition-opacity.duration-1000.ease-in-out
        {:style {:opacity (if (or (nil? progress-width) upload-completed?)
                            "0" "100")}}
        [:div.width-transition.absolute.bg-blue-400.h-full.rounded-l-md
         {:style {:width (str (or progress-width 0) "%")}}]
        [:div.flex-1.relative.m-4
         (tr [:import-session/files-uploading] [all-items])]
        [:div.flex-1.text-right.relative.m-4
         (cc/button {:on-click      #(rf/dispatch-sync [::cancel-upload (:db/id session)])
                     :icon          i/trash
                     :icon-position :right
                     :size          :small
                     :kind          :ghost
                     :class-name    "bg-white"}
                    (tr [:cancel]))]])
     (when (seq attachments)
       [:<>
        [:h3 (tr [:import-session/uploaded-files])]
        [:div.border.border-solid.border-gray-300.rounded-md.flex.relative.leading-8.h-18
         [:div.flex-1.relative.m-4.flex
          (tr [:import-session/files] [(count attachments)])
          (when (> added-items-count 0)
            [:div.px-1.py-auto.font-bold.text-ui-white.text-m.text-center.rounded-md.ml-4.transition-opacity.duration-1000.ease-in-out.bg-ui-violet
             {:class (if upload-completed? "opacity-100" "opacity-0")}
             (str "+" added-items-count)])]
         [:div.flex-1.text-right.relative.m-4
          [:span.mt-4.mr-2 ((<sub [::date-util/date-time-fn]) (-> attachments first :entity/created))]
          (when (du/in-state? :import-session.state/draft session)
            [ui/modal-confirmation-button
             {:id                  "delete-import-attachments"
              :tr                  tr
              :modal-class         "text-left"
              :modal-title         (tr [:import-session/delete-attachments])
              :trigger-button-text (tr [:delete])
              :trigger-button-opts {:icon          i/trash
                                    :icon-position :right
                                    :size          :small
                                    :kind          :ghost
                                    :class-name    "bg-white"}
              :on-yes-click        #(>evt [::delete-import-attachments (:db/id session)])}
             (tr [:import-session/delete-attachments-confirmation])])]]])]))


(defn process-file-upload [session-id tr attach-file-fn {:keys [file fullpath component-id file-hash]}]
  (>evt [::upload/add-pending-file component-id file-hash])
  (comm/send-command-execution
    {:command         :import/initialize-upload
     :data            {:content-type      (upload/file-type file)
                       :file/md5          file-hash
                       :file/full-path    fullpath
                       :import-session-id session-id}
     :on-success      [::upload/start-file-upload
                       file
                       file-hash
                       attach-file-fn
                       component-id
                       fullpath
                       ::on-upload-error]
     :on-not-modified [::upload/file-already-uploaded tr file file-hash component-id ::on-upload-error]
     :on-bad-request  [::upload/upload-failure (util/mmap {:md5      file-hash
                                                           :on-error ::on-upload-error} component-id)]
     :on-error        [::upload/upload-failure (util/mmap {:md5      file-hash
                                                           :on-error ::on-upload-error} component-id)]
     :on-server-error [::upload/upload-failure (util/mmap {:md5      file-hash
                                                           :on-error ::on-upload-error} component-id)]}))

;; Match the backend's `property-attachment-type?` so the default cannot cause row errors.
(defn property-attachment-types [group attachment-types]
  (let [available-ids (when group
                        (set (entities/get-id group :group/available-property-attachments)))]
    (->> attachment-types
         (filter #(and (= :attachment-type.kind/property (:attachment-type/kind %))
                       (contains? (or available-ids #{})
                                  (or (:db/id %)
                                      (first (:attachment-type/group+key %)))))))))

(defn default-attachment-types [import-type group attachment-types]
  (if (= import-type :import-session.type/property-attachment)
    (property-attachment-types group attachment-types)
    attachment-types))

(defn session-view [{{{:keys [session-id group-id]} :path} :parameters
                     :as                                   match}]
  (let [tr                      (<sub [::gas/group-tr])
        group                   (<sub [::gas/group])
        session                 (<sub [::entities/entity session-id])
        selected-sheet          (<sub [::selected-sheet session-id])
        cancel-upload?          (<sub [::cancel-upload?])
        import-type             (:import-session/type session)
        attachment-types        (default-attachment-types import-type group (<sub [::gas/attachment-types]))
        ctx                     (util/mmap session-id group-id)
        default-attachment-type (<sub [::default-attachment-type (:db/id session)])
        summary-loading?        (<sub [::loading-summary? session-id])
        summary-error           (<sub [::summary-error session-id])
        missing-file?           (<sub [::missing-file? session-id])]
    [acommon/admin-page-v2
     (util/mmap {:title (tr [:view/group.admin.import.session])}
                match)
     [:div
      (if (<sub [::fetching? session-id])
        [section/section-skeleton]
        [:div
         [acommon/section
          {:title (tr [:data-import/imported-file])}
          [imported-file ctx]
          (when (<sub [::multiple-sheets? session-id])
            [:div
             [:h4 (:name selected-sheet)]
             (when (du/in-state? :import-session.state/draft session)
               [:div.mt-2
                [ui-select/select
                 {:id           "import-sheet-select"
                  :allow-empty? false
                  :values       (-> session :import-session/file-summary :sheets)
                  :label-text   (tr [:data-import/select-sheet])
                  :val->str     :name
                  :value        selected-sheet
                  :on-change    #(>evt [::select-sheet group-id session-id (:ix %)])}]])])
          (cond
            summary-loading?
            [:div.flex.w-full.justify-center
             (cc/loading-spinner {:with-overlay false})]

            missing-file?
            [ui/help (tr [:data-import/please-upload])]

            summary-error
            [:div.flex.w-full.justify-center.text-xl.text-ui-red
             (str (tr [:import-session/previous-file-error]) ": " summary-error)]

            :else
            [sheet-selections (util/mmap {:sheet selected-sheet}
                                         group-id session-id import-type)])
          (when (attachment-import? import-type)
            [:div.w-1-2.mt-10
             (cc/select
               {:id          "default-attachment-type-select"
                :class-name  "w-full"
                :disabled    (not (du/in-state? :import-session.state/draft session))
                :helper-text (tr [:import-session/default-attachment-type-info])
                :label-text  (tr [:import-session/default-attachment-type])
                :value       (:db/id default-attachment-type)
                :on-change   #(>evt [::select-default-attachment-type group-id session-id (-> % futil/tval futil/parse-int)])}
               (when (not default-attachment-type)
                 [ui/placeholder-select-item tr :none])
               (for-frag [att-type attachment-types]
                 (cc/select-item {:text  (-> (:attachment-type/names att-type)
                                             (i18n-model/get-text-from-entities-or-map :en)
                                             (or ""))
                                  :value (:db/id att-type)})))])
          (when (<sub [::too-many-rows? session-id])
            [ui/warning (tr [:data-import/too-many-rows]
                            [(str import-model/max-allowed-rows)])])
          (when-some [duplicate-settings (<sub [::duplicate-settings session-id])]
            [ui/warning (str (tr [:data-import.error-report/duplicates-found-in]) (str/join ", " (map #(tr [%]) duplicate-settings)))])
          [:div.mt-8.flex.gap-x-4
           (when (and (du/in-state? :import-session.state/done session)
                      (<sub [::ff/enabled? :feature-flag.id/duplicate-import-session]))
             [ui/modal-confirmation-button
              {:on-yes-click        #(>evt [::duplicate-session group-id session-id])
               :tr                  tr
               :trigger-button-opts {:kind :tertiary
                                     :icon i/copy}
               :trigger-button-text (tr [:data-import/duplicate-session])}
              [ui/bubble-content (tr [:data-import/duplicate-session-help])]])
           (when ((du/in-state-fn :import-session.state/draft
                                  :import-session.state/in-progress
                                  :import-session.state/imported) session)
             [ui/modal-confirmation-button
              {:on-yes-click        #(>evt [::remove-session group-id session-id])
               :tr                  tr
               :trigger-button-opts {:kind :tertiary
                                     :icon i/trash}
               :trigger-button-text (tr [:data-import/remove-session])}
              (tr [:data-import/remove-session-help])])
           (when (du/in-state? :import-session.state/imported session)
             (cc/button {:on-click #(>evt [::restore-to-draft group-id session-id])
                         :kind     :tertiary}
                        (tr [:data-import/restore-to-draft])))
           (when-not (du/in-state? :import-session.state/done session)
             (cc/button {:on-click #(>evt [::start-import group-id session-id])
                         :disabled (not (<sub [::can-start-read? session-id]))}
                        (tr [:data-import/start])))
           (when (du/in-state? :import-session.state/in-progress session)
             [:div.flex.items-center.ml-6
              (cc/loading-spinner {:with-overlay false :small true})
              [:span.ml-2 (tr [:data-import/in-progress])]])]]
         (when (attachment-import? import-type)
           [:section
            (when (du/in-state? :import-session.state/draft session)
              [:<>
               [:h3 (tr [:import-session/upload-files])]
               [ui/help (tr [:import-session/upload-help])]
               (if cancel-upload?
                 [:div.flex.items-center.ml-6
                  (cc/loading-spinner {:with-overlay false :small true})
                  [:span.ml-2 (tr [:data-import/import-canceled])]]
                 [:<>
                  [upload/upload-area "upload-files-for-import"
                   {:additional-help        (tr [:import-session/attachment-upload-help])
                    :accept-types           file-formats/convertable-accept-value-for-input
                    :on-processing-files    #(rf/dispatch-sync [::start-progress-bar session-id %])
                    :on-error               ::on-upload-error
                    :attach-file-v2-fn      (fn [{:keys [file-id filename file-mime-type md5-base64 fullpath]}]
                                              (>evt [::add-file-for-import
                                                     tr
                                                     group-id
                                                     session-id
                                                     file-id
                                                     filename
                                                     file-mime-type
                                                     md5-base64
                                                     fullpath]))
                    :process-file-upload-fn (partial process-file-upload session-id)
                    :select-directories?    true}]])])
            [uploaded-files tr session]])])
      [errors-section ctx]
      [entities-section ctx]]]))

(defn session-breadcrumb [{:keys [match tr]}]
  (let [params     (-> match :parameters :path)
        session-id (:session-id params)
        filename   (<sub [::filename session-id])]
    [:view/group.admin.import.session
     params
     (or filename (tr [:view/group.admin.import.session]))]))

(rf/reg-event-fx ::fetch-templates
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/property-attribute-templates
                    :method     :get
                    :data       {:group-id group-id}
                    :on-success [::entities/merge-entity-db]}}))

(def import-session-route
  {:name        :view/group.admin.import.session
   :view        session-view
   :public?     false
   :breadcrumb  {:items [session-breadcrumb]}
   :own-layout? true
   :parameters  {:path  {:group-id   s/Int
                         :session-id s/Int}
                 :query {(s/optional-key :page) s/Int}}
   :controllers [{:parameters {:path  [:group-id :session-id]
                               :query [:page]}
                  :start      (fn [{{:keys [group-id session-id]} :path
                                    {:keys [page]}                :query}]
                                (>evt [::fetch-templates group-id])
                                (>evt [::fetch-session group-id session-id (or page 0)])
                                (>evt [::gas/fetch-attachment-types-in-use group-id]))}]})
